import React from 'react'

const PrivacyPage = () => {
    return (
        <div className="page-container">
            <div className="content-card">
                <span className="privacy-badge">Zero Data Collection Policy</span>
                <h1>Privacy Policy</h1>
                <p className="last-updated">Last updated: May 19, 2026</p>
                
                <p>
                    This Privacy Policy describes Our policies and procedures on the collection, use, and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
                </p>
                
                <p>
                    <strong>Widgets</strong> ("the Application", "the Company", "We", "Us", or "Our") is designed to respect and prioritize your privacy. We believe that your personal data belongs to you. Therefore, <strong>We do not collect, store, or transmit any personal data or personally identifiable information (PII) from our users.</strong>
                </p>

                <h1>1. Information We Do NOT Collect</h1>
                <p>
                    Unlike many other applications, we do not require you to create an account, register, or provide any personal details to use our Widgets applications. We do not collect or request:
                </p>
                <ul>
                    <li><strong>Personal Details:</strong> Names, usernames, email addresses, phone numbers, or social media profiles.</li>
                    <li><strong>Financial Information:</strong> Credit card numbers, bank account details, or payment histories (all transactions are securely handled by Google Play Billing / Apple App Store).</li>
                    <li><strong>Real-Time Location:</strong> We do not track or store your precise GPS coordinates.</li>
                    <li><strong>Personal Content:</strong> We do not access or collect your private photos, documents, or files.</li>
                </ul>

                <h1>2. On-Device Storage & Local Processing</h1>
                <p>
                    All of your widget designs, customized themes, configuration options, and settings are saved <strong>locally</strong> on your device (using secure local storage interfaces such as AsyncStorage and MMKV). This data never leaves your device and is not uploaded to our servers.
                </p>

                <h1>3. Device Permissions & How They Are Used</h1>
                <p>
                    To enable specific widget features, the Application may request access to certain system permissions. These permissions are processed entirely on-device:
                </p>
                <ul>
                    <li>
                        <strong>Health Data (Health Connect / Apple Health):</strong> If you grant permission, the Application reads step counts, activity, or health indicators solely to display them on your local widgets. This data remains on-device and is never uploaded, saved, or shared with third parties.
                    </li>
                    <li>
                        <strong>Storage & Photos:</strong> Used solely to allow you to select your own wallpapers or custom backgrounds for widgets. We do not access other images and do not upload your files.
                    </li>
                    <li>
                        <strong>Notifications & Background Access:</strong> Used to update widgets in real-time (such as clock or battery status) and send periodic system notifications to keep widgets synchronized.
                    </li>
                </ul>

                <h1>4. Third-Party Services</h1>
                <p>
                    We may utilize standard industry tools and SDKs to ensure the performance, stability, and growth of our service. These third-party platforms are governed by their respective privacy policies:
                </p>
                <ul>
                    <li>
                        <strong>Firebase Analytics & Remote Config:</strong> We use Google Firebase to gather completely anonymized, aggregated diagnostic data (such as application crashes, device models, operating systems, and anonymous usage patterns). This helps us fix bugs and optimize the experience. No personal identifying information is transmitted.
                    </li>
                    <li>
                        <strong>Firebase Cloud Messaging (FCM):</strong> Used to deliver push notifications. This does not involve collecting or storing personal data.
                    </li>
                    <li>
                        <strong>In-App Purchase SDKs (Google Play / Apple App Store):</strong> All purchases and subscriptions are handled securely by Google or Apple. The billing process is isolated from our servers, and we never view or store your payment details.
                    </li>
                </ul>

                <h1>5. Children's Privacy</h1>
                <p>
                    Our Service does not target, nor do we knowingly collect or solicit any data from children under the age of 13. Since we do not collect any personal information whatsoever, parents and guardians can be fully confident that no child's information is being compiled, stored, or shared.
                </p>

                <h1>6. Changes to this Privacy Policy</h1>
                <p>
                    We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date at the top.
                </p>

                <h1>7. Contact Us</h1>
                <p>
                    If you have any questions or feedback regarding this Privacy Policy, please feel free to reach out to us:
                </p>
                <ul>
                    <li>By email: <a href="mailto:ganeshglive@gmail.com">ganeshglive@gmail.com</a></li>
                </ul>
            </div>
        </div>
    )
}

export default PrivacyPage